import $ from 'jquery'
import '../plugins/fullpage.scrollHorizontally.min'
import fullpage from 'fullpage.js/dist/fullpage.extensions.min'
import { gsap } from 'gsap'
import Cookies from 'js-cookie'

/**
 * Achievements block animation.
 * @param direction
 * @returns {gsap.core.Timeline}
 */
const achievementsAnim = (direction) => {
  const tl = gsap.timeline({
    paused: true,
    delay: 0.3,
  })
  const el = document.querySelectorAll('.feed-achievement')
  return tl.from(el, {
    duration: 0.6,
    stagger: window.matchMedia('(max-width: 1199px)').matches ? 0.2 : 0,
    y: direction === 'down' ? 500 : -500,
    ease: 'back',
  })
}

/**
 * Skills block animation.
 * @param direction
 * @returns {gsap.core.Timeline}
 */
const skillsAnim = (direction) => {
  const tl = gsap.timeline({ paused: true, delay: 0.3 })
  const el = document.querySelectorAll('.feed-skill')
  return tl.from(el, {
    duration: 0.6,
    stagger: 0.2,
    y: direction === 'down' ? 200 : -200,
    opacity: 0,
    ease: 'back',
  })
}

/**
 * Text image block animation.
 * @param direction
 * @returns {gsap.core.Timeline}
 */
const tibAnim = (direction) => {
  const tl = gsap.timeline({ paused: true, delay: 0.25 })
  const el = $('.text-image-block').parents('.fp-overflow')[0]
  return tl.from(el, {
    duration: 1,
    xPercent: direction === 'down' ? 100 : -100,
    ease: 'elastic.out(1.2, 1.6)',
  })
}

/**
 * Clients block animation.
 * @param direction
 * @returns {gsap.core.Timeline}
 */
const clientsAnim = (direction) => {
  const tl = gsap.timeline({ paused: true, delay: 0.25 })
  const el = $('.clients-block').parents('.fp-overflow')[0]
  return tl.from(el, {
    duration: 1,
    xPercent: direction === 'right' ? 100 : -100,
    ease: 'elastic.out(1.2, 1.6)',
  })
}

/**
 * Blog block posts animation.
 * @param direction
 * @returns {gsap.core.Timeline}
 */
const blogAnim = () => {
  const tl = gsap.timeline({ paused: true, delay: 0.3 })
  const el = document.querySelectorAll('.blog-block__col-item')
  return tl.from(el, {
    duration: 1,
    stagger: 0.2,
    // y: direction === 'right' ? 200 : -200,
    y: 200,
    opacity: 0,
    ease: 'power4',
  })
}

/**
 * Social Media block animation.
 * @returns {gsap.core.Timeline}
 */
const smAnim = () => {
  const tl = gsap.timeline({ paused: true, delay: 0.5 })
  const el = document.querySelectorAll('.social-media-block__container')
  return tl.from(el, {
    duration: 2,
    opacity: 0,
    ease: 'power4',
  })
}

const initFp = () => {
  if (!document.body.classList.contains('page-template-page-home')) {
    return false
  }

  $('.site-footer').appendTo($('.home-blocks'))

  $('.site-footer, .cta-block')
    .removeClass('vn-block')
    .wrapAll('<div class="vn-block vn-footer-block"><div></div></div>')

  $('.social-media-block, .blog-block')
    .removeClass('vn-block')
    .wrapAll('<div class="sm-and-blog-blocks"></div>')

  $('.text-image-block, .clients-block, .sm-and-blog-blocks')
    .removeClass('vn-block')
    .wrapAll('<div class="vn-block vn-horizontal-blocks"></div>')
    .wrap('<div class="slide"></div>')

  window.fp = new fullpage('.home-blocks', {
    autoScrolling: true,
    licenseKey: 'J2GL9-4KD97-PKRT7-6W6JK-MYFCM',
    sectionSelector: '.vn-block',
    normalScrollElements: '.achievements-block__achievements',
    // Extensıons start.
    scrollHorizontallyKey:
      'MTBkbWx6YVc5dWMyNXZkWFpsYkd4bGN5NWpiMjA9Q0VfMVc4YzJOeWIyeHNTRzl5YVhwdmJuUmhiR3g1MlV4',
    scrollHorizontally: true,
    responsiveSlidesKey:
      'aDRkbWx6YVc5dWMyNXZkWFpsYkd4bGN5NWpiMjA9anZfcHZuY21WemNHOXVjMmwyWlZOc2FXUmxjdz09YnI4',
    responsiveSlides: true,
    // Extensions end.
    responsiveWidth: 992,
    slidesNavigation: false,
    loopHorizontal: false,
    credits: {
      enabled: false,
    },
    afterLoad: function (origin) {
      if (origin.index === 0 && Cookies.get('homeAnimated') !== '1') {
        animateHero()
      }
    },
    onLeave: function (origin, destination, direction) {
      if (window.matchMedia('(max-width: 991px)').matches) {
        return
      }

      const target = destination.item

      if (target.classList.contains('achievements-block')) {
        achievementsAnim(direction).play()
      }

      if (target.classList.contains('skills-block')) {
        skillsAnim(direction).play()
      }

      if (target.classList.contains('vn-horizontal-blocks')) {
        tibAnim(direction).play()
      }

      // if (
      //   origin.item.classList.contains('vn-footer-block') &&
      //   direction === 'up'
      // ) {
      //   blogAnim(direction).play()
      //   smAnim().play()
      // }
    },
    onSlideLeave(section, origin, destination, direction) {
      if (window.matchMedia('(max-width: 991px)').matches) {
        return
      }

      const target = destination.item

      if ($(target).find('.clients-block').length) {
        clientsAnim(direction).play()
      }

      if ($(target).find('.text-image-block').length) {
        tibAnim(direction).play()
      }

      if ($(target).find('.blog-block').length) {
        blogAnim(direction).play()
        smAnim().play()
      }
    },
  })

  window.dispatchEvent(new Event('resize'))

  $('.vn-block')
    .not('.hero, .text-image-block')
    .find('.fp-overflow > div')
    .wrap('<div class="container fp-added-container"></div>')

  window.fp.reBuild()

  return window.fp
}

window.addEventListener('load', initFp)

/**
 * Animate hero section on first page load.
 */
const animateHero = () => {
  gsap.set('.hero__image', { width: 360, height: 500 })
  gsap
    .timeline()
    .fromTo(
      '.hero__image',
      { yPercent: 10, bottom: 0 },
      {
        yPercent: 50,
        bottom: '50%',
        duration: 1,
        ease: 'elastic.out(0.5, 0.4)',
      }
    )
    .to('.hero__image', {
      duration: 0.6,
      width: '100%',
      height: '100%',
      ease: 'elastic.out(0.6, 0.5)',
    })
    .then(() => {
      const elements = document.querySelector('.hero__wrapper-inner')
      elements.style.opacity = 1
      elements.style.visibility = 'visible'

      const hero = document.querySelector('.hero')
      hero.style.height = '100%'
    })

  Cookies.set('homeAnimated', 1)
}

$('.go-top').on('click', function () {
  if (
    window.matchMedia('(max-width: 991px)').matches ||
    !$('body').hasClass('page-template-page-home')
  ) {
    document
      .getElementsByTagName('html')[0]
      .scrollIntoView({ behavior: 'smooth' })
  } else {
    window.fp.moveTo(1)

    // Reset horizontal container
    const slidesContainer = $('.fp-slidesContainer')
    slidesContainer.find('.active').removeClass('active')
    slidesContainer.find('>:first-child').addClass('active')
    slidesContainer.css('transform', 'translate3d(0px, 0px, 0px)')
  }
})

// Sert à faire fonctionner le défilement des slides sur la droite avec la flèche du bas et vers la gauche avec la flèche du haut
$(document).keydown(function (e) {
  if (e.which == 40) {
    // Désigne la fleche du bas
    window.fp.moveSlideRight() // Déplacer le curseur d'une diapositive vers la droite
  } else if (e.which == 38) {
    // Désigne la fleche du haut
    window.fp.moveSlideLeft() // Déplacer le curseur d'une diapositive vers la gauche
  }
})

$('.js-home-mouse').on('click', function () {
  window.fp.moveSectionDown();
})
